import { showError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { resetCreateSubscription } from '../create_subscription_slice'
import {
  checkoutInfoAdditionalQuantitySelector,
  checkoutInfoOverrideQuantitySelector,
  checkoutSelectedCurrencySelector,
  checkoutSelectedPlanSelector
} from '../modals/subscription_modal/payment_modal/subscription_checkout/selectors'

export const fetchCheckoutInfo = createAsyncThunk(
  'CheckoutInfo/fetch',
  async (_params = {}, { dispatch, getState }) => {
    const state = getState()
    const additionalQuantity = checkoutInfoAdditionalQuantitySelector(state)
    const overrideQuantity = checkoutInfoOverrideQuantitySelector(state)
    const plan = checkoutSelectedPlanSelector(state)
    const currency = checkoutSelectedCurrencySelector(state)

    const [success, checkoutInfo] = await httpRequest({
      url: '/api/billing/checkout_info',
      method: 'GET',
      params: {
        tier: plan,
        additional_quantity: additionalQuantity,
        override_quantity: overrideQuantity,
        currency,
      }
    })

    if (!success) {
      dispatch(resetCreateSubscription())
      dispatch(showError(I18n.t('errors.billing.server')))
      return null
    }
    return checkoutInfo
  }
)
